import Results from "./Results.vue";

export default Results;
